import { Button } from 'grommet'
import styled from 'styled-components'

export const ScrollButton = styled(Button)`
  align-self: flex-end;
  bottom: ${({ theme }) => theme.spaces[4]}px;
  opacity: ${({ visibility }) => (visibility ? 100 : 0)};
  ${({ visibility }) => !visibility && 'display: none;'}
  position: sticky;
  right: ${({ theme }) => theme.spaces[4]}px;
  transition: all 0.25s ease-in-out;
  z-index: 5;

  &:hover {
    transform: scale(1.2);
  }
`
